import { getI18n } from "react-i18next";

const creditRatingLabel = (rating: number) => {
    const i18n = getI18n();

    if (rating <= 579) {
        return i18n.t("CreditRatingLabel.needsWork");
    } else if (rating >= 580 && rating <= 669) {
        return i18n.t("CreditRatingLabel.fair");
    } else if (rating >= 670 && rating <= 739) {
        return i18n.t("CreditRatingLabel.good");
    } else if (rating >= 740 && rating <= 799) {
        return i18n.t("CreditRatingLabel.veryGood");
    } else {
        return i18n.t("CreditRatingLabel.excellent");
    }
};

export default creditRatingLabel;
